
const RetrainingSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Retraining and Refresher Courses
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-8">
            <p>
              In some cases, retraining is essential. For example, OSHA requires retraining if an employee is observed not following safety protocols, such as operating a forklift in an unsafe manner. We also recommend periodic refresher training to keep safety practices in employees' minds, whether through formal sessions or informal toolbox meetings.
            </p>
          </div>
          
          <div className="text-center mb-8">
            <img 
              src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/826f11fa8e0d2b7c7493578755bae300.jpeg"
              alt="OSHA Training CPR"
              className="w-full max-w-xl mx-auto rounded-lg shadow-lg object-cover object-top"
            />
          </div>
          
          <div className="text-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetrainingSection;